import { render, staticRenderFns } from "./CompanyStatusModal.vue?vue&type=template&id=a86bfc1a"
import script from "./CompanyStatusModal.vue?vue&type=script&lang=js"
export * from "./CompanyStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports